import { render, staticRenderFns } from "./ForgotPasswordComponent.vue?vue&type=template&id=47ae72fa&scoped=true&"
import script from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPasswordComponent.vue?vue&type=style&index=0&id=47ae72fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ae72fa",
  null
  
)

export default component.exports